import React from "react";
import useUser from "../../../../hooks/super/useUser";
import { ConfirmModal } from "../../../../components/pages/_new/super/design";

function RestoreUserModal({ open, handleClose, uid, userName, adminFlag }) {
  const { restoreUser, restoreAdmin } = useUser();
  const [busy, setBusy] = React.useState(false);

  const list = Array.isArray(userName) ? userName : [];
  const subjects = adminFlag ? "administrator" : "user";
  const plural = list.length > 1 ? "s" : "";

  const onConfirm = async () => {
    if (busy) return;
    setBusy(true);
    try {
      if (adminFlag) await restoreAdmin(uid);
      else await restoreUser(uid);
      handleClose();
    } finally {
      setBusy(false);
    }
  };

  return (
    <ConfirmModal
      open={open}
      onClose={handleClose}
      onConfirm={onConfirm}
      variant="success"
      title={`Restore ${subjects}${plural}?`}
      body={`The selected ${subjects}${plural} will be restored to active status.`}
      items={list.map((u) => ({ id: u.id, title: u.email }))}
      submitLabel="Restore"
      loading={busy}
    />
  );
}

export default RestoreUserModal;
